import { render, staticRenderFns } from "./BreakpointBtn.vue?vue&type=template&id=ffef1c48&"
import script from "./BreakpointBtn.vue?vue&type=script&lang=js&"
export * from "./BreakpointBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports